import { withLazyComponent } from '@document/utils/lazy-component';
import { lazy } from 'react';

export const ActivityPage = withLazyComponent(
  lazy(async () => ({
    default: (await import('./ActivityPage')).ActivityPage,
  }))
);
